<template>
    <div v-if="consumpData && consumpData.values" class="panel-wrapper">
        <div class="content-row shadow-box">
            <div class="col-3">
                <template v-if="hasConsData">
                    <energy-overview-panel :data="overviewDataFirst" :timeDsvn="timeDsvn"></energy-overview-panel>
                </template>
                <div v-else class="empty-placeholder">
                    <common-title-panel :title="'에너지 소비 개요'" :subTitle="''"></common-title-panel>
                    <div class="placeholder-content">
                        <span class="placeholder-icon">
                            <i class="fas fa-exclamation-circle"></i>
                        </span>
                        <span class="placeholder-text">표시할 데이터가 없습니다.</span>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="stack-table-container">
                    <template v-if="hasSrcChartData">
                        <StackChart
                            ref="energyConsumptionChart"
                            :title="'에너지원별 소비량 구성'"
                            :subTitle="`(${selectFirstUnit(consumpData.values.src.unit)} · ${timeLabel})`"
                            :chartHeight="27"
                            :data="consumpData.values.src.chartData"
                            :color="analyzeConfig.colorSet"
                            :xAxisLabel="xAxisLabel"
                        />
                    </template>
                    <div v-else class="empty-placeholder">
                        <common-title-panel
                            :title="'에너지원별 소비량 구성'"
                            :subTitle="`(${selectFirstUnit(consumpData.values.src.unit)} · ${timeLabel})`"
                        ></common-title-panel>
                        <div class="placeholder-content">
                            <span class="placeholder-icon">
                                <i class="fas fa-exclamation-circle"></i>
                            </span>
                            <span class="placeholder-text">표시할 데이터가 없습니다.</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <!-- <h5>{{ "consumption section3" }}</h5> -->
                <div class="stack-table-container">
                    <template v-if="hasWeekChartData">
                        <StackChart
                            ref="dayOfWeekChart"
                            :title="'요일별 에너지 소비 수준'"
                            :subTitle="`(${selectFirstUnit(this.consumpData.values.week.unit)} · 일)`"
                            :chartHeight="27"
                            :data="updateWeekEng"
                            :color="analyzeConfig.colorSet"
                            :xAxisLabel="consumpData.values.week.regDt"
                        />
                    </template>
                    <div v-else class="empty-placeholder">
                        <common-title-panel
                            :title="'요일별 에너지 소비 수준'"
                            :subTitle="`(${selectFirstUnit(this.consumpData.values.week.unit)} · 일)`"
                        ></common-title-panel>
                        <div class="placeholder-content">
                            <span class="placeholder-icon">
                                <i class="fas fa-exclamation-circle"></i>
                            </span>
                            <span class="placeholder-text">표시할 데이터가 없습니다.</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <!-- <h5>{{ "consumption section3" }}</h5> -->
                <template v-if="hasHourChartData">
                    <BarChart
                        ref="timeEnergyChart"
                        :title="'시간대별 에너지 소비수준'"
                        :subTitle="`(${selectFirstUnit(this.consumpData.values.week.unit)} · 시)`"
                        :chartHeight="27"
                        :data="updateHourEng"
                        :color="analyzeConfig.colorSet"
                        :xAxisLabel="consumpData.values.hour.regDt"
                        :showLabel="false"
                        :usageAnalysis="consumpData.values.hour.usageAnalysis"
                    />
                </template>
                <div v-else class="empty-placeholder">
                    <common-title-panel
                        :title="'시간대별 에너지 소비수준'"
                        :subTitle="`(${selectFirstUnit(this.consumpData.values.week.unit)} · 시)`"
                    ></common-title-panel>
                    <div class="placeholder-content">
                        <span class="placeholder-icon">
                            <i class="fas fa-exclamation-circle"></i>
                        </span>
                        <span class="placeholder-text">표시할 데이터가 없습니다.</span>
                    </div>
                </div>
            </div>
        </div>
        <div class="content-row shadow-box">
            <div class="col-3">
                <template v-if="hasProdData">
                    <energy-overview-panel :data="overviewDataSecond" :timeDsvn="timeDsvn"></energy-overview-panel>
                </template>
                <div v-else class="empty-placeholder">
                    <common-title-panel :title="'에너지 발전 개요'" :subTitle="''"></common-title-panel>
                    <div class="placeholder-content">
                        <span class="placeholder-icon">
                            <i class="fas fa-exclamation-circle"></i>
                        </span>
                        <span class="placeholder-text">표시할 데이터가 없습니다.</span>
                    </div>
                </div>
            </div>
            <div class="col-3">
                <div class="stack-table-container">
                    <template v-if="hasRenChartData">
                        <StackChart
                            ref="energyRenewalChart"
                            :title="'신재생 에너지원별 발전량 구성'"
                            :subTitle="`(${selectFirstUnit(this.consumpData.values?.ren?.unit)} · ${timeLabel})`"
                            :chartHeight="27"
                            :data="consumpData.values.ren.chartData"
                            :color="analyzeConfig.colorSet"
                            :xAxisLabel="xAxisLabel"
                        />
                    </template>
                    <div v-else class="empty-placeholder">
                        <common-title-panel
                            :title="'신재생 에너지원별 발전량 구성'"
                            :subTitle="`(${selectFirstUnit(this.consumpData.values?.ren?.unit)} · ${timeLabel})`"
                        ></common-title-panel>
                        <div class="placeholder-content">
                            <span class="placeholder-icon">
                                <i class="fas fa-exclamation-circle"></i>
                            </span>
                            <span class="placeholder-text">표시할 데이터가 없습니다.</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-6">
                <template v-if="hasTrendData">
                    <TrendChart
                        ref="energyRenewalSeveralChart"
                        :title="'신재생 에너지원별 발전량 추이'"
                        :chartHeight="27"
                        :data="updateTrendEng"
                        :subTitle="`(${selectFirstUnit(this.consumpData.values.trend.unit)} · ${timeLabelDown})`"
                        :color="analyzeConfig.colorSet"
                        :xAxisLabel="consumpData.values.trend.regDt"
                        :showLabel="false"
                        explanation="발전량"
                    />
                </template>
                <div v-else class="empty-placeholder">
                    <common-title-panel
                        :title="'신재생 에너지원별 발전량 추이'"
                        :subTitle="`(${selectFirstUnit(this.consumpData.values.trend?.unit)} · ${timeLabelDown})`"
                    ></common-title-panel>
                    <div class="placeholder-content">
                        <span class="placeholder-icon">
                            <i class="fas fa-exclamation-circle"></i>
                        </span>
                        <span class="placeholder-text">표시할 데이터가 없습니다.</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EnergyOverviewPanel from "./EnergyOverviewPanel.vue";
import BarChart from "../charts/BarChart";
import TrendChart from "../charts/TrendChart";
import StackChart from "../charts/StackChart.vue";
import analyzeConfig from "../analyzeConfig.json";
import { isEmptyChartData } from "@/utils/dataValidation";
import CommonTitlePanel from "../panels/CommonTitlePanel.vue";

export default {
    props: ["consumpData"],
    components: {
        BarChart,
        TrendChart,
        EnergyOverviewPanel,
        StackChart,
        CommonTitlePanel,
    },
    data() {
        return {
            dummyData: null,
            analyzeConfig: null,
            xAxisLabelMonth: ["전월", "당월", "전년동월"],
            xAxisLabelYear: ["작년", "올해", "재작년"],
            overviewDataFirst: null,
            overviewDataSecond: null,
            chartRefs: [], // 차트 refs 추적
        };
    },
    computed: {
        xAxisLabel() {
            const label = this.timeDsvn == "YEAR" ? ["작년", "올해", "재작년"] : ["전월", "당월", "전년동월"];
            return label ?? [];
        },
        timeLabel() {
            return this.consumpData?.headers[0]?.timeDsvn === "MONTH" ? "월" : "년";
        },
        timeLabelDown() {
            return this.consumpData?.headers[0]?.timeDsvn === "MONTH" ? "일" : "월";
        },
        timeDsvn() {
            return this.consumpData?.headers[0]?.timeDsvn;
        },
        updateWeekEng() {
            const chartData = this.consumpData.values.week.chartData;
            return Object.keys(chartData)
                .filter((key) => key !== "total")
                .reduce((acc, key) => {
                    acc[key] = chartData[key];
                    return acc;
                }, {});
        },
        updateHourEng() {
            return { 소비량: this.consumpData.values.hour.chartData.total };
        },
        updateTrendEng() {
            const chartData = this.consumpData.values.trend.chartData;
            const keys = Object.keys(chartData);
            const length = this.consumpData.values.trend.regDt.length || 0;

            const sumArray = Array.from({ length }, (_, idx) => {
                const sum = keys.reduce((sum, key) => {
                    const value = chartData[key][idx];
                    return sum + (typeof value === "number" ? value : 0);
                }, 0);
                return Math.round(sum * 10) / 10;
            });

            chartData.total = sumArray;

            return chartData;
        },
        hasSrcChartData() {
            if (!this.consumpData?.values?.src?.chartData) return false;
            return !isEmptyChartData(this.consumpData.values.src.chartData);
        },
        hasWeekChartData() {
            return !isEmptyChartData(this.updateWeekEng);
        },
        hasHourChartData() {
            return !isEmptyChartData(this.updateHourEng);
        },
        hasRenChartData() {
            if (!this.consumpData?.values?.ren?.chartData) return false;
            return !isEmptyChartData(this.consumpData.values.ren.chartData);
        },
        hasConsData() {
            if (!this.consumpData?.values?.cons) return false;
            const cons = this.consumpData.values.cons;
            // 주요 필드 중 하나라도 null이 아니고 0이 아닌 값이 있는지 확인
            const hasValue =
                (cons.goal != null && cons.goal !== 0) ||
                (cons.currentMonth != null && cons.currentMonth !== 0) ||
                (cons.currentYear != null && cons.currentYear !== 0) ||
                (cons.prevMonth != null && cons.prevMonth !== 0) ||
                (cons.prevYear != null && cons.prevYear !== 0) ||
                (cons.prevYearMonth != null && cons.prevYearMonth !== 0) ||
                (cons.prevPrevYear != null && cons.prevPrevYear !== 0) ||
                (cons.savingRate != null && cons.savingRate !== 0);
            return hasValue;
        },
        hasProdData() {
            if (!this.consumpData?.values?.prod) return false;
            const prod = this.consumpData.values.prod;
            // 주요 필드 중 하나라도 null이 아니고 0이 아닌 값이 있는지 확인
            const hasValue =
                (prod.currentMonthGen != null && prod.currentMonthGen !== 0) ||
                (prod.currentYearGen != null && prod.currentYearGen !== 0) ||
                (prod.prevMonthGen != null && prod.prevMonthGen !== 0) ||
                (prod.prevYearGen != null && prod.prevYearGen !== 0) ||
                (prod.currentMonthCons != null && prod.currentMonthCons !== 0) ||
                (prod.currentYearCons != null && prod.currentYearCons !== 0) ||
                (prod.currentMonthSrf != null && prod.currentMonthSrf !== 0) ||
                (prod.currentYearSrf != null && prod.currentYearSrf !== 0);
            return hasValue;
        },
        hasTrendData() {
            const trendEng = this.updateTrendEng;
            if (!trendEng || typeof trendEng !== "object") return false;
            // 모든 키의 배열(outerTemp 포함)이 null이거나 0인지 확인
            const keys = Object.keys(trendEng);
            if (keys.length === 0) return false;
            return keys.some((key) => {
                const arr = trendEng[key];
                if (!arr || !Array.isArray(arr)) return false;
                return arr.some((item) => item != null && item !== 0);
            });
        },
    },
    watch: {
        consumpData: {
            immediate: true,
            deep: true,
            handler() {
                if (this.hasConsData) {
                    this.overviewDataFirst = this.readyOverviewData("consumption");
                }
                if (this.hasProdData) {
                    this.overviewDataSecond = this.readyOverviewData("generate");
                }
            },
        },
    },
    mounted() {
        // 차트 refs 수집
        this.collectChartRefs();
    },

    beforeDestroy() {
        this.cleanupAllCharts();
    },

    created() {
        this.analyzeConfig = analyzeConfig;
    },

    destroyed() {
        // console.log(`[DESTROYED] ConsumptionAnalysisPanel`);
    },
    methods: {
        /* 차트 refs 수집 */
        collectChartRefs() {
            this.chartRefs = [
                "energyConsumptionChart",
                "energyRenewalChart",
                "energyRenewalSeveralChart",
                "dayOfWeekChart",
                "timeEnergyChart",
            ];
        },

        /* 모든 차트 정리 */
        cleanupAllCharts() {
            this.chartRefs.forEach((refName) => {
                const chartRef = this.$refs[refName];
                if (chartRef && typeof chartRef.cleanupChart === "function") {
                    chartRef.cleanupChart();
                }
            });
        },

        selectFirstUnit(unitBox) {
            if (!unitBox) {
                return "-";
            }
            return Object.values(unitBox)[0];
        },
        readyOverviewData(purpose) {
            if (!this.consumpData) return;
            let unit, title, color, table, chart;
            let currValue, prevLeft, prevRight, prevRate, prevRightRate, maxValue, goalValue, savingRate;
            let timeDsvn = this.timeDsvn;

            if (purpose === "consumption") {
                if (this.timeDsvn === "MONTH") {
                    unit = this.consumpData.values.cons.unit["목표량"] ?? "kWh";
                    goalValue = this.consumpData.values.cons.goal ?? 0;
                    currValue = this.consumpData.values.cons.currentMonth ?? 0;
                    savingRate = this.consumpData.values.cons.savingRate ?? 0;
                    prevLeft = this.consumpData.values.cons.prevMonth ?? 0;
                    prevRight = this.consumpData.values.cons.prevYearMonth ?? 0;
                } else if (this.timeDsvn === "YEAR") {
                    unit = this.consumpData.values.cons.unit["목표량"] ?? "kWh";
                    goalValue = this.consumpData.values.cons.goal ?? 0;
                    currValue = this.consumpData.values.cons.currentYear ?? 0;
                    savingRate = this.consumpData.values.cons.savingRate ?? 0;
                    prevLeft = this.consumpData.values.cons.prevYear ?? 0;
                    prevRight = this.consumpData.values.cons.prevPrevYear ?? 0;
                }

                prevRate = prevLeft ? (((currValue - prevLeft) / prevLeft) * 100).toFixed(2) : 0;
                prevRightRate = prevRight ? (((currValue - prevRight) / prevRight) * 100).toFixed(2) : 0;
                maxValue = Math.max(currValue, prevLeft, prevRight);

                title = "에너지 소비 개요";
                color = "#FF5252";
                table = [{ 목표량: [goalValue, unit] }, { 소비량: [currValue, unit] }, { 절감률: [savingRate, "%"] }];
                chart = {
                    max: maxValue,
                    prevLeft: { per: prevRate, value: [prevLeft, unit] },
                    now: { value: [currValue, unit] },
                    prevRight: { per: prevRightRate, value: [prevRight, unit] },
                };
            } else if (purpose === "generate") {
                let consumpValue, currGenEngValue, currSelfEngRate;
                if (this.timeDsvn === "MONTH") {
                    unit = this.consumpData.values.prod.unit["소비량"] ?? "kWh";

                    consumpValue = this.consumpData.values.prod.currentMonthCons ?? 0;
                    currGenEngValue = this.consumpData.values.prod.currentMonthGen ?? 0;
                    currSelfEngRate = this.consumpData.values.prod.currentMonthSrf ?? 0;
                    prevLeft = this.consumpData.values.prod.prevMonthGen ?? 0;
                    prevRight = this.consumpData.values.cons.prevYearMonthGen ?? 0;
                } else if (this.timeDsvn === "YEAR") {
                    unit = this.consumpData.values.prod.unit["소비량"] ?? "kWh";

                    consumpValue = this.consumpData.values.prod.currentYearCons ?? 0;
                    currGenEngValue = this.consumpData.values.prod.currentYearGen ?? 0;
                    currSelfEngRate = this.consumpData.values.prod.currentYearSrf ?? 0;
                    prevLeft = this.consumpData.values.prod.prevYearGen ?? 0;
                    prevRight = this.consumpData.values.cons.prevPrevYearGen ?? 0;
                }

                unit = this.consumpData.headers.find((item) => item.key === "발전량").unitSmallCode;

                prevRate = prevLeft ? (((currGenEngValue - prevLeft) / prevLeft) * 100).toFixed(2) : 0;
                prevRightRate = prevRight ? (((currGenEngValue - prevRight) / prevRight) * 100).toFixed(2) : 0;
                maxValue = Math.max(currGenEngValue, prevLeft, prevRight);

                title = "에너지 발전 개요";
                color = "#448AFF";
                table = [
                    { 소비량: [consumpValue, unit] },
                    { 발전량: [currGenEngValue, unit] },
                    { 자립률: [currSelfEngRate, "%"] },
                ];
                chart = {
                    prevLeft: { per: prevRate, value: [prevLeft, unit] },
                    max: maxValue,
                    now: { value: [currGenEngValue, unit] },
                    prevRight: { per: prevRightRate, value: [prevRight, unit] },
                };
            }

            return { title, color, table, chart, timeDsvn };
        },
        resizeChart() {
            this.$nextTick(() => {
                if (this.$refs.energyConsumptionChart) this.$refs.energyConsumptionChart.resizeChart();
                if (this.$refs.energyRenewalChart) this.$refs.energyRenewalChart.resizeChart();
                if (this.$refs.energyRenewalSeveralChart && this.hasTrendData)
                    this.$refs.energyRenewalSeveralChart.resizeChart();
                if (this.$refs.dayOfWeekChart) this.$refs.dayOfWeekChart.resizeChart();
                if (this.$refs.timeEnergyChart) this.$refs.timeEnergyChart.resizeChart();
            });
        },
    },
};
</script>

<style scoped>
.panel-wrapper {
    width: 100%;
    height: 100%;
    padding: 10px;
    display: flex;
    flex-direction: column;
    gap: 10px; /* row 간격 */
}

.content-row {
    display: flex;
    width: 100%;
    height: calc(50% - 5px); /* 두 영역 사이 gap 을 감안한 정확한 50% 분할 */
    padding: 10px;
    box-sizing: border-box;
    background-color: white;
    border-radius: 10px;
}

.shadow-box {
    box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.15);
}

.stack-table-container {
    width: 100%;
    height: 100%;
}

.empty-placeholder {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    gap: 0;
    color: #999;
}

.placeholder-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    width: 100%;
}

.placeholder-icon {
    font-size: 2rem;
    color: #ccc;
}

.placeholder-text {
    font-size: 0.9rem;
    color: #666;
}
</style>
